import { ReactElement, ReactNode } from 'react'
import { Box } from '@mui/material'
import EndDrawModeButton from '../EndDrawModeButton'

interface Props {
  /** Name of the drawn element type, e.g. "Öffnungen". */
  elementLabel: string
  onEnd: () => void
  'data-cy'?: string
  children: ReactNode
}

/** Drawer content of a drawing mode, headed by its "<Element> einzeichnen beenden" button. */
const DrawModePane = ({
  elementLabel,
  onEnd,
  'data-cy': dataCy,
  children,
}: Props): ReactElement => (
  <>
    <Box p={1}>
      <EndDrawModeButton elementLabel={elementLabel} onClick={onEnd} data-cy={dataCy} />
    </Box>
    {/* The panes start with differing top paddings/margins; the button owns the gap instead. */}
    <Box sx={{ '& > :first-child': { mt: 0, pt: 0 } }}>{children}</Box>
  </>
)

export default DrawModePane
